import * as types from './constants';

// Get My Creators Groups
export const getMyCreatorsGroupsRequest = data => (
  { type: types.GET_MY_CREATORS_GROUPS_REQUEST, payload: data }
);

export const getMyCreatorsGroupsDone = data => (
  { type: types.GET_MY_CREATORS_GROUPS_DONE, payload: data }
);

export const getMyCreatorsGroupsFailed = errors => (
  { type: types.GET_MY_CREATORS_GROUPS_FAILED, payload: errors }
);

export const getMyCreatorsGroupsReset = () => (
  { type: types.GET_MY_CREATORS_GROUPS_RESET }
);

// Poll My Creators Groups
export const pollMyCreatorsGroupsRequest = data => (
  { type: types.POLL_MY_CREATORS_GROUPS_REQUEST, payload: data }
);

export const pollMyCreatorsGroupsDone = data => (
  { type: types.POLL_MY_CREATORS_GROUPS_DONE, payload: data }
);

// Operations
export const toggleMyCreatorsGroups = data => (
  { type: types.TOGGLE_MY_CREATORS_GROUPS, payload: data }
);

export const toggleAllMyCreatorsGroups = data => (
  { type: types.TOGGLE_ALL_MY_CREATORS_GROUPS, payload: data }
);

export const myCreatorsGroupsSetPage = data => (
  { type: types.MY_CREATORS_GROUPS_SET_PAGE, payload: data }
);